module.exports = "<img [src]=\"data.image\" />"